(() => {
  const root = document.querySelector('.ds-configurator');
  if (!root) return;

  const variantId = root.getAttribute('data-variant-id');
  const requiredCount = parseInt(root.getAttribute('data-required-count') || '10', 10);

  const openBtn = root.querySelector('.ds-open-btn');
  const modal = root.querySelector('.ds-modal');
  const closeEls = root.querySelectorAll('[data-close]');

  const tabsEl = root.querySelector('[data-tabs]');
  const gridEl = root.querySelector('[data-grid]');
  const selectedEl = root.querySelector('[data-selected]');

  const countEl = root.querySelector('[data-count]');
  const requiredEls = root.querySelectorAll('[data-required]');

  const msgEl = root.querySelector('[data-msg]');
  const atcBtn = root.querySelector('[data-atc]');

  requiredEls.forEach(el => (el.textContent = String(requiredCount)));

  const dataScript = root.querySelector('[data-ds-data]');
  const data = JSON.parse(dataScript.textContent);

  // IMPORTANT: no default collection selected (Xerjoff-like)
  let activeCollectionId = null;

  // selected ids set (no duplicates)
  const selected = new Set();

  function msg(text) {
    msgEl.textContent = text || '';
  }

  function openModal() {
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');

  // Lock background scroll
  document.body.classList.add('ds-modal-open');
  }

  function closeModal() {
  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');

  // Unlock background scroll
  document.body.classList.remove('ds-modal-open');
  }

  function renderTabs() {
    tabsEl.innerHTML = '';

    // Optional "Brand" header behavior can be added later; for now just tabs
    data.collections.forEach(col => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = col.title;
      btn.className = col.id === activeCollectionId ? 'is-active' : '';

      btn.addEventListener('click', () => {
        activeCollectionId = col.id;
        renderTabs();
        renderGrid();
      });

      tabsEl.appendChild(btn);
    });
  }

  function renderGrid() {
    gridEl.innerHTML = '';

    if (!activeCollectionId) {
      gridEl.innerHTML = `
        <div class="ds-empty" >
          CUSTOMISE YOUR DISCOVERY SET<br><br>
          Create Your Own Discovery Set By Selecting The 10 Fragrances Of Your Choice.
        </div>
      `;
      return;
    }

    const minis = data.minis.filter(m => m.collectionId === activeCollectionId);

    minis.forEach(mini => {
      const card = document.createElement('div');
      card.className = 'ds-card' + (selected.has(mini.id) ? ' is-selected' : '');

      card.innerHTML = `
        <div class="ds-card-media">
          <img src="${mini.image}" alt="${mini.title}">
        </div>
        <div class="ds-card-title">${mini.title}</div>
      `;

      card.addEventListener('click', () => toggleMini(mini.id));

      gridEl.appendChild(card);
    });
  }

  function renderSelectedList() {
    selectedEl.innerHTML = '';
    const items = [...selected]
      .map(id => data.minis.find(m => m.id === id))
      .filter(Boolean);

    if (items.length === 0) {
      selectedEl.innerHTML = `<div class="ds-selected-empty">No items selected yet.</div>`;
      return;
    }

    items.forEach((m) => {
      const row = document.createElement('div');
      row.className = 'ds-selected-item';
      row.innerHTML = `
        <div class="ds-selected-name">${m.title}</div>
        <button type="button" class="ds-selected-remove" aria-label="Remove">✕</button>
      `;
      row.querySelector('button').addEventListener('click', () => {
        selected.delete(m.id);
        updateUI();
        renderGrid();
      });
      selectedEl.appendChild(row);
    });
  }

  function toggleMini(id) {
 if (selected.has(id)) {
    selected.delete(id);
  } else {
    if (selected.size >= requiredCount) {
      msg(`You can only select ${requiredCount}.`);
      return;
    }
    selected.add(id);
  }

  updateUI();
  renderGrid();
}

  function updateUI() {
 countEl.textContent = String(selected.size);
  renderSelectedList();

  const ok = selected.size === requiredCount;
  atcBtn.disabled = !ok;

  // Always show a message (never empty) to stop footer jumping
  if (ok) {
    msg('You can proceed to cart.');
  } else {
    msg(`Select ${requiredCount - selected.size} more to continue.`);
  }
}
  // --- Cart drawer refresh/open (theme-agnostic best effort) ---
  async function refreshCartDrawer() {
    // Many themes re-render cart drawer with section rendering
    // Try common section handles
    const sectionHandles = ['cart-drawer', 'cartDrawer', 'cart-drawer-items'];

    for (const handle of sectionHandles) {
      try {
        const res = await fetch(`/?sections=${encodeURIComponent(handle)}`, { credentials: 'same-origin' });
        if (!res.ok) continue;

        const json = await res.json();
        const html = json[handle];
        if (!html) continue;

        const temp = document.createElement('div');
        temp.innerHTML = html;

        const newDrawer =
          temp.querySelector('cart-drawer') ||
          temp.querySelector('.cart-drawer') ||
          temp.querySelector('[data-cart-drawer]') ||
          temp.querySelector('#CartDrawer') ||
          temp.querySelector('[id*="CartDrawer"]');

        const currentDrawer =
          document.querySelector('cart-drawer') ||
          document.querySelector('.cart-drawer') ||
          document.querySelector('[data-cart-drawer]') ||
          document.querySelector('#CartDrawer') ||
          document.querySelector('[id*="CartDrawer"]');

        if (newDrawer && currentDrawer) {
          currentDrawer.replaceWith(newDrawer);
        }

        // Try to open drawer via exposed component method
        const drawerEl = document.querySelector('cart-drawer');
        if (drawerEl && typeof drawerEl.open === 'function') {
          drawerEl.open();
          return true;
        }

        // Fallback: click cart icon/link (many themes open drawer this way)
        const cartTrigger =
          document.querySelector('[data-header-cart]') ||
          document.querySelector('a[href="/cart"]') ||
          document.querySelector('button[aria-label*="cart" i]') ||
          document.querySelector('[aria-controls*="CartDrawer" i]');

        if (cartTrigger) {
          cartTrigger.click();
          return true;
        }

        return true;
      } catch (e) {
        // continue next handle
      }
    }

    return false;
  }

  async function addToCart() {
    if (!variantId) {
      msg('Variant missing.');
      return;
    }
    if (selected.size !== requiredCount) return;

    const items = [...selected]
      .map(id => data.minis.find(m => m.id === id))
      .filter(Boolean);

    // Better property labels for admin/packing
    const properties = {};
    items.forEach((m, i) => {
      properties[`Selection ${i + 1}`] = m.title;
    });

    atcBtn.disabled = true;
    msg('Adding to cart...');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          properties
        })
      });

      if (!res.ok) throw new Error(await res.text());

      msg('Added. Opening cart...');
      // Try to refresh & open cart drawer immediately
      const ok = await refreshCartDrawer();

      // If we couldn't open, at least ensure the cart is updated:
      // some themes will update on next interaction; we won't redirect.
      closeModal();
      msg('');

      // Re-enable button for next time (optional)
      atcBtn.disabled = false;

      // Optionally reset selections after add:
      // selected.clear(); activeCollectionId = null; updateUI(); renderTabs(); renderGrid();

      if (!ok) {
        // last resort: you can uncomment to redirect if you want
        // window.location.href = '/cart';
      }
    } catch (err) {
      console.error(err);
      msg('Could not add to cart. Try again.');
      atcBtn.disabled = false;
    }
  }

  openBtn.addEventListener('click', () => {
    msg('');
    renderTabs();
    renderGrid();
    updateUI();
    openModal();
  });

  closeEls.forEach(el => el.addEventListener('click', closeModal));
  atcBtn.addEventListener('click', addToCart);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
})();
